import Axios, { CreateAxiosDefaults, InternalAxiosRequestConfig } from 'axios';
import cookie from 'js-cookie';
import { BASE_URL_SUFFIX, JSON_LD_HEADER_ACCEPT } from '~/clientApi';

const defaultInterceptorsReq = (req: InternalAxiosRequestConfig) => {
  const accessToken = cookie.get('accessToken');

  // Append the access token if it exists and there is no manual Authorization header defined
  if (accessToken && !req.headers.Authorization)
    req.headers['Authorization'] = `Bearer ${accessToken}`;

  return req;
};

export const makeApiClient = (
  baseURL: string,
  config?: CreateAxiosDefaults,
  interceptorsReq: (
    req: InternalAxiosRequestConfig,
  ) => InternalAxiosRequestConfig = defaultInterceptorsReq,
) => {
  const axiosClient = Axios.create({
    baseURL,
    headers: {
      Accept: JSON_LD_HEADER_ACCEPT,
    },
    ...config,
  });

  axiosClient.interceptors.request.use(interceptorsReq);

  return axiosClient;
};

export const apiClientV2 = makeApiClient(
  `${process.env.NEXT_PUBLIC_API_RESOURCE}/${BASE_URL_SUFFIX}`,
);
